export default "__VITE_ASSET__BTKJxMLX__"